import { styled } from '../jss-style';
import commonStyle, { animations } from './common';

const useCommonStyle = styled(commonStyle, 'common');
export { commonStyle, useCommonStyle, animations };
export default useCommonStyle;
